import httpClient, { ConexaResponse } from '@/services/httpClient'

export const inviteToVideoCall = async (
  sessionId: string,
  guestName: string,
): Promise<ConexaResponse<string>> => {
  const response = await httpClient.get(
    `/chamada/compartilhar/link/${sessionId}/${guestName}/true`,
  )
  return response.data
}
